<mat-progress-bar
  class="progress"
  mode="query"
  *ngIf="(checkPhoneLoading$ | async) || (phoneUpdateLoading$ | async)"
></mat-progress-bar>

<div id="update-phone-wrepper" fxFlex="column" fxFlexAlign="center stretch">
  <mat-toolbar> تائید حساب کاربری</mat-toolbar>
  <section class="info">
    <h3 class="title">شماره تلفن خود را وارد کنید</h3>
    <p style="color: var(--accent)" class="desc" *ngIf="this.userData.googleId">
      شما با گوگل ثبت نام کرده اید و نیاز دارید تا شماره تلفن خود را ثبت کنید.
    </p>
  </section>
  <div id="form-wrapper" fxLayout="column" fxLayoutAlign="start stretch">
    <form [formGroup]="phoneUpdateForm">
      <mat-form-field style="width: 100%" appearance="outline">
        <mat-label> شماره تلفن </mat-label>
        <mat-spinner
          matSuffix
          [diameter]="20"
          *ngIf="this._checkingPhoneNumber"
        ></mat-spinner>
        <input type="tel" matInput formControlName="phone" />
      </mat-form-field>
    </form>

    <div id="errors" *ngIf="phoneUpdateForm.dirty && !phoneUpdateForm.valid">
      <ul>
        <li *ngIf="phone.dirty && phone.hasError('required')">
          شماره تلفن همراه الزامی است.
        </li>

        <li
          class="error"
          color="warn"
          *ngIf="
            phone.dirty &&
            phone.errors &&
            phone.errors['length'] > 0 &&
            phone.errors['pattern']
          "
        >
          شماره تلفن وارد شده قابل تایید نیست. لطفا از الگو پیروی کنید
        </li>

        <li *ngIf="phone.dirty && phone.hasError('phoneExists')">
          شماره تلفن {{ phone.value }} قبلا استفاده شده است
        </li>
      </ul>
    </div>

    <div class="actions">
      <button
        [disabled]="phone.invalid || _checkingPhoneNumber"
        (click)="updateUserPhone()"
        mat-flat-button
        id="submit-btn"
        color="primary"
      >
        <span> ثبت شماره </span>
      </button>
    </div>
  </div>
</div>
